import React from 'react';
import { useTranslation } from 'react-i18next';
import { CancelIcon, LockLockedIcon } from 'assets/icons';
import { UserRole } from 'domains/user';
import { theme } from 'styles';
import { Flex, Icon, Text, WithTooltip } from 'UI';
import { hasUserAnyRight, hasUserR3WithSubscriptionL234 } from 'utils';

export const getHasAccessToTechnicalLinks = ({
  isIam,
  versionCode,
  userRights,
}: {
  isIam: boolean;
  versionCode: string | undefined;
  userRights: UserRole[] | undefined;
}): boolean => {
  if (isIam) {
    return hasUserAnyRight(
      [UserRole.IAM_FAST_ACCESS, UserRole.IAM_PRO_ACCESS, UserRole.IAM_PRO_PLUS_ACCESS],
      userRights,
    );
  }
  return Boolean(versionCode) && hasUserR3WithSubscriptionL234(userRights);
};

export const NotAuthorizedLabel = ({ label }: { label: string }) => {
  const { t } = useTranslation();
  return (
    <WithTooltip
      title={t('catalog.parts.category.unlock_feature_by_upgrading', 'Unlock feature by upgrading your subscription')}
    >
      <Text type={'lead_text_white'} noWrap>
        {label}
        <Icon ml={5} size={14} IconComponent={LockLockedIcon} color={theme.color.information_active} />
      </Text>
    </WithTooltip>
  );
};

export const NotLoadedLabel = ({ label }: { label: string }) => {
  return (
    <Text type={'lead_text_white'} noWrap>
      {label}
    </Text>
  );
};

export const notAuthorizedTab = ({ key, dataCy, label }: { key: number; dataCy: string; label: string }) => {
  return {
    key,
    dataCy,
    label: <NotAuthorizedLabel label={label} />,
    link: '',
    component: <></>,
    staticWithColor: theme.color.information_active,
  };
};

export const NotAvailableForVehicleLabel = ({ label }: { label: string }) => {
  const { t } = useTranslation();
  return (
    <WithTooltip
      title={t('catalog.parts.category.data_unavailable_for_vehicle', 'Data unavailable for current vehicle')}
    >
      <Flex align={'center'}>
        <Text type={'lead_text_white'} noWrap>
          {label}
        </Text>
        <Icon ml={5} size={25} IconComponent={CancelIcon} color={theme.color.grey80} />
      </Flex>
    </WithTooltip>
  );
};

export const notAvailableTab = ({
  key,
  dataCy,
  label,
  link,
}: {
  key: number;
  dataCy: string;
  label: string;
  link: string;
}) => {
  return {
    key,
    label: <NotAvailableForVehicleLabel label={label} />,
    component: <></>,
    link,
    dataCy,
    staticWithColor: theme.color.grey80,
  };
};

export const notLoadedTab = ({
  key,
  label,
  link,
  dataCy,
}: {
  key: number;
  label: string;
  link: string;
  dataCy: string;
}) => {
  return {
    key,
    label: <NotLoadedLabel label={label} />,
    component: <></>,
    link,
    dataCy,
  };
};
